// states
const states = {
  // 加载
  isLoading: false,

  // 是否查看协议
  isProtocol: false,

  isNoQuestion: true,

  // 顶部导航
  navBar: {
    title: '',
    type: 'center',
    tips: '',
    color: ''
  },

  // 问题服务列表
  lists: [],

  // 医生
  doctor: {},

  // 快问医生页面
  isTip: false,
  isSlider: false,
  isLeave: false,

  question: {
    status: 'disabled', // normal, disabled, less, more, sensitive
    describe: '',
    imgs: [],
    count: 0,
    id: null
  },

  price: null,  // 提问价格
  bannerUrl: null,  // banenrUrl
  onlineTime: '服务在线时间：00:00-23:59', // 在线时间
  newMessageStaus: false, // 新消息状态

  isRate: false,
  token: null,
  constantData: null, // 获取后台配置的静态数据
  memberState: null,  // 会员状态 0 - 非会员 1 - 会员  2 - 当天到期会员  3 - 三天内到期且非当天到期会员
  goodsVipInfo: {
    skuBenefitType: null,  // 产品是否设置了会员权益
    otherPrice: null
  }
};

export default states;



// WEBPACK FOOTER //
// ./src/stores/states.js